<template>
  <div v-if="config" class="apply">
    <div class="price">
      <div class="actual">{{ config.price }}</div>
      <div v-if="config.origin_price && showTagLeft" class="del-price">
        官网价 {{ config.origin_price }}
      </div>
    </div>
    <div class="desc-wrap">
      <div v-if="config.tag" class="label" :style="{ background: bgColor }">
        {{ config.tag }}
      </div>
      <div v-if="config.tips" class="desc" v-html="config.tips"></div>
      <div v-if="config.origin_price && !showTagLeft" class="del-price">
        官网价 {{ config.origin_price }}
      </div>
    </div>
    <button
      :class="{ disable: !isAgree, large: !config.tag && !config.tips }"
      :style="{ background: bgColor }"
      class="btn-apply"
      @click="handleUserAction"
    >
      {{ config.button || '马上报名' }}
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import SmoothScroll from '@/lib/SmoothScroll';

@Component({})
export default class Apply extends Vue {
  @Prop({ type: Boolean }) isAgree!: boolean;
  @Prop() config!: any;
  @Prop() bgColor!: string;

  scoller: SmoothScroll | null = null;

  mounted() {
    const ele = document.getElementById('t-scroll-container');
    if (ele) {
      this.scoller = new SmoothScroll(ele);
    }
  }

  handleUserAction() {
    if (!this.isAgree) {
      this.$nextTick(() => {
        this.scoller && this.scoller.scrollToBottom();
      });
      return;
    }
    this.$emit('apply');
  }

  get showTagLeft() {
    const { tag, tips } = this.config;
    return !tag || (tag && tips);
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/helps.scss';
@import '../../styles/apply.scss';
</style>